module.exports = "/static/assets/7d7ec7dadfa937027f379bb16b60bbf4.png";